import {Component, OnInit, NgZone, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '@layouts/login/authentication.service';

import {Title} from '@angular/platform-browser';
import {SharedService} from '@shared/shared.service';
import {environment} from '@myenv/environment';
import {enMessage} from '@shared/en-us-message';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
  // public tenantId = environment.tenantId;
  public cmImageUrl = environment.cmImageUrl;
  public footerText = environment.footerText;
  public userDetails: any = {};
  responseMessage: any = {};
  resetToken: string = '';
  confirmNewPassword: Boolean = false;
  NewPassword: Boolean = false;
  ConfirmPassword: Boolean = false;
  passwordSetError = '';

  constructor(private sharedService: SharedService, private route: ActivatedRoute, private authenticationService: AuthenticationService, private router: Router, private ngzone: NgZone,  private title: Title) {
  }

  ngOnInit() {
    this.title.setTitle('Reset password'+ environment.title_text)
    // this.resetToken = localStorage.getItem('resetToken');
    this.route.params.subscribe(params => {
      this.resetToken = params.id;
    })

  }

  onClickResetPassword(isValid: boolean) {
    if(isValid) {
      this.passwordSetError = '';
      if (this.userDetails.newPassword !== this.userDetails.confirmPassword) {
        this.confirmNewPassword = true;

      } else {
        this.authenticationService.ResetPassword(this.userDetails, this.resetToken).subscribe((res) => {

          this.ngzone.run(() => {
            this.router.navigate(['/login'], {queryParams: {msg: 2}})
          })

        }, error => {
          if (error && error.errorCode === 'CU055') {
            this.ngzone.run(() => {
              this.router.navigate(['/reset-password-expired'], {replaceUrl: true});
            });
            return;
          }
          const message = this.getPasswordSetErrorMessage(error);
          this.ngzone.run(() => {
            this.passwordSetError = message;
            this.responseMessage = {
              success: false,
              message,
            };
            this.sharedService.setResponseMessage(this.responseMessage);
          });
        })
      }
    }
    // else {
    //   this.confirmNewPassword = false;
    // }


  }

  confirmPass() {
    if(this.userDetails.confirmPassword) {
      this.confirmNewPassword = false;
    }
    this.clearPasswordSetError();
  }

  clearPasswordSetError() {
    this.passwordSetError = '';
  }

  viewNewPassword() {
    this.NewPassword = !this.NewPassword;
  }

  viewConfirmPassword() {
    this.ConfirmPassword = !this.ConfirmPassword;
  }

  private getPasswordSetErrorMessage(error: any): string {
    const fallback = 'Your password could not be set. Please try again later';
    if (error == null) {
      return fallback;
    }
    if (typeof error === 'string') {
      return this.isUsableErrorMessage(error) ? error.trim() : fallback;
    }
    const candidates = [
      error.message,
      error.error && error.error.message,
      typeof error.error === 'string' ? error.error : null,
      error.errorMessage,
      error.error && error.error.errorMessage,
      error.errorCode && enMessage[error.errorCode],
      error.error && error.error.errorCode && enMessage[error.error.errorCode],
    ];
    for (const candidate of candidates) {
      if (this.isUsableErrorMessage(candidate)) {
        return candidate.trim();
      }
    }
    return fallback;
  }

  private isUsableErrorMessage(value: any): boolean {
    return (
      typeof value === 'string' &&
      !!value.trim() &&
      value.trim() !== 'Server error' &&
      !value.startsWith('Http failure response')
    );
  }

}
